var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9334 10.8001C11.9216 10.8001 13.5334 9.18832 13.5334 7.2001C13.5334 5.21187 11.9216 3.6001 9.9334 3.6001C7.94517 3.6001 6.3334 5.21187 6.3334 7.2001C6.3334 9.18832 7.94517 10.8001 9.9334 10.8001Z",
    fill: "#BA0060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9334 13.2001C13.9098 13.2001 17.1334 16.4236 17.1334 20.4001H2.7334C2.7334 16.4236 5.95695 13.2001 9.9334 13.2001Z",
    fill: "#BA0060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5334 8.4001C19.5334 7.73736 18.9961 7.2001 18.3334 7.2001C17.6707 7.2001 17.1334 7.73736 17.1334 8.4001V9.6001H15.9334C15.2707 9.6001 14.7334 10.1374 14.7334 10.8001C14.7334 11.4628 15.2707 12.0001 15.9334 12.0001H17.1334V13.2001C17.1334 13.8628 17.6707 14.4001 18.3334 14.4001C18.9961 14.4001 19.5334 13.8628 19.5334 13.2001V12.0001H20.7334C21.3961 12.0001 21.9334 11.4628 21.9334 10.8001C21.9334 10.1374 21.3961 9.6001 20.7334 9.6001H19.5334V8.4001Z",
    fill: "#BA0060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUserIcon);
export default __webpack_public_path__ + "static/media/new-user-icon.b3b31a102c535f5a8a541058d37b6298.svg";
export { ForwardRef as ReactComponent };